import {
  CreateTransient,
  theme as defaultTheme,
  Typography,
} from "@mindlercare/ui-web";
import { forwardRef, ReactNode } from "react";
import { styled } from "styled-components";

import { ContentfulRichText } from "../ContentfulRichText";
import type { ContentfulEntryLink, PageWithContent } from "../types";

export type IcbtPageProps = {
  page: PageWithContent;
  enableAudio?: boolean;
  enableVideo?: boolean;
  isCurrentProgress?: boolean;
  renderQuestionnaire?: (entry: ContentfulEntryLink) => ReactNode;
  renderPatientNote?: (entry: ContentfulEntryLink) => ReactNode;
};

export const IcbtPage = forwardRef<HTMLDivElement, IcbtPageProps>(
  (
    {
      page,
      enableAudio,
      enableVideo,
      isCurrentProgress,
      renderQuestionnaire,
      renderPatientNote,
    },
    ref,
  ) => {
    return (
      <div ref={ref}>
        <CurrentProgressIndicator $isCurrentProgress={isCurrentProgress}>
          <Typography insensitive variant="h4" sx={{ paddingBottom: "10px" }}>
            {page.title}
          </Typography>
          <ContentfulRichText
            document={page.content.json}
            links={page.content.links}
            enableAudio={enableAudio}
            enableVideo={enableVideo}
            renderQuestionnaire={renderQuestionnaire}
            renderPatientNote={renderPatientNote}
          />
        </CurrentProgressIndicator>
      </div>
    );
  },
);

IcbtPage.displayName = "IcbtPage";

const CurrentProgressIndicator = styled.div<
  CreateTransient<{ isCurrentProgress?: boolean }>
>`
  position: relative;
  padding-left: ${(p) => (p.$isCurrentProgress ? "8px" : 0)};

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0px;
    height: 100%;
    width: 4px;
    background-color: ${defaultTheme.COLORS.BLUE_MEDIUM};
    opacity: ${(p) => (p.$isCurrentProgress ? 1 : 0)};
  }
`;
